/* Moon Modesty — theme.js
   Vanilla JS: announcement rotation, mega menu, mobile menu,
   AJAX cart drawer, product form, GSAP reveals, Lenis smooth scroll. */
(function () {
  "use strict";

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
  var locale = document.documentElement.lang || "fr";

  /* Same output as Liquid's | money filter: uses the shop's currency format
     (Shopify admin > Settings > General > Store currency), so every price on the
     site looks identical and the merchant can change the format without code. */
  function money(cents) {
    var fmt = window.__mmMoneyFormat;
    var value = (parseInt(cents, 10) || 0) / 100;
    function group(n, decimals, thousands, decimalSep) {
      var fixed = n.toFixed(decimals).split(".");
      var intPart = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fixed[1] ? intPart + decimalSep + fixed[1] : intPart;
    }
    if (fmt && /\{\{\s*\w+\s*\}\}/.test(fmt)) {
      var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
        switch (key) {
          case "amount_no_decimals": return group(value, 0, ",", ".");
          case "amount_with_comma_separator": return group(value, 2, ".", ",");
          case "amount_no_decimals_with_comma_separator": return group(value, 0, ".", ",");
          case "amount_with_apostrophe_separator": return group(value, 2, "'", ".");
          case "amount_no_decimals_with_space_separator": return group(value, 0, " ", ",");
          case "amount_with_space_separator": return group(value, 2, " ", ",");
          default: return group(value, 2, ",", ".");
        }
      });
      var tmp = document.createElement("span");
      tmp.innerHTML = out;
      return tmp.textContent || out;
    }
    try {
      return new Intl.NumberFormat(locale, { style: "currency", currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    } catch (e) {
      return "€" + value.toFixed(2);
    }
  }

  /* ---------- Lenis smooth scroll ---------- */
  var lenis = null;
  if (window.Lenis && !reducedMotion) {
    lenis = new window.Lenis();
    window.__lenis = lenis;
    var lenisRaf = function (time) {
      lenis.raf(time);
      window.requestAnimationFrame(lenisRaf);
    };
    window.requestAnimationFrame(lenisRaf);
  }

  /* Animation watchdog: if rAF is throttled (background tab, energy saver),
     GSAP never advances and .from()/.reveal elements stay invisible.
     Force the final state so content is never hidden. */
  function forceVisible() {
    var sel = ".reveal, .hero__eyebrow, .hero__sub, .hero__cta, .hero__title span, .hero__title em";
    document.querySelectorAll(sel).forEach(function (el) {
      el.style.opacity = "1";
      el.style.transform = "none";
    });
  }
  setTimeout(function () {
    if (!window.gsap || window.gsap.ticker.frame < 5) forceVisible();
  }, 2500);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") forceVisible();
  });

  /* Sticky header: promote the section wrapper (parent of .site-header) */
  var headerEl = document.querySelector(".site-header");
  if (headerEl) {
    var wrapper = headerEl.closest(".shopify-section") || headerEl.parentElement;
    if (wrapper) wrapper.classList.add("section-header-sticky");
  }

  /* ---------- Announcement bar rotation ---------- */
  document.querySelectorAll("[data-announcement]").forEach(function (bar) {
    var msgs = bar.querySelectorAll(".announcement-bar__msg");
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove("is-active");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-active");
    }, 5000);
  });

  /* ---------- Mega menu (hover with delays) ---------- */
  var OPEN_DELAY = 120, CLOSE_DELAY = 200;
  var openTimer = null, closeTimer = null;
  var header = document.querySelector(".site-header");

  function closeAllMega() {
    document.querySelectorAll(".mega.is-open").forEach(function (m) { m.classList.remove("is-open"); });
  }
  document.querySelectorAll("[data-mega-trigger]").forEach(function (trigger) {
    var id = trigger.getAttribute("data-mega-trigger");
    var panel = document.getElementById(id);
    if (!panel) return;
    trigger.addEventListener("mouseenter", function () {
      clearTimeout(openTimer); clearTimeout(closeTimer);
      openTimer = setTimeout(function () { closeAllMega(); panel.classList.add("is-open"); }, OPEN_DELAY);
    });
    trigger.addEventListener("focus", function () { closeAllMega(); panel.classList.add("is-open"); });
    panel.addEventListener("mouseenter", function () { clearTimeout(closeTimer); });
    panel.addEventListener("mouseleave", function () {
      closeTimer = setTimeout(closeAllMega, CLOSE_DELAY);
    });
  });
  if (header) {
    header.addEventListener("mouseleave", function () {
      clearTimeout(openTimer);
      closeTimer = setTimeout(closeAllMega, CLOSE_DELAY);
    });
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeAllMega(); closeCart(); } });

  /* ---------- Mobile menu ---------- */
  var mobileToggle = document.querySelector("[data-mobile-toggle]");
  var mobileMenu = document.querySelector("[data-mobile-menu]");
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener("click", function () { mobileMenu.classList.toggle("is-open"); });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector("[data-cart-drawer]");
  var backdrop = document.querySelector("[data-cart-backdrop]");

  function openCart() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    if (backdrop) backdrop.classList.add("is-open");
    if (lenis) lenis.stop();
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    if (backdrop) backdrop.classList.remove("is-open");
    if (lenis) lenis.start();
    document.body.style.overflow = "";
  }
  window.__openCart = openCart;

  document.querySelectorAll("[data-cart-open]").forEach(function (el) {
    el.addEventListener("click", function (e) { e.preventDefault(); refreshCart().then(openCart); });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (el) {
    el.addEventListener("click", closeCart);
  });
  if (backdrop) backdrop.addEventListener("click", closeCart);

  var FREE_SHIP_CENTS = parseInt((drawer && drawer.getAttribute("data-free-shipping")) || "15000", 10);

  function renderCart(cart) {
    if (!drawer) return;
    var counts = document.querySelectorAll("[data-cart-count]");
    counts.forEach(function (c) { c.textContent = "(" + cart.item_count + ")"; });

    var ship = drawer.querySelector("[data-ship-label]");
    var bar = drawer.querySelector("[data-ship-bar]");
    if (ship && bar) {
      var remaining = Math.max(0, FREE_SHIP_CENTS - cart.total_price);
      var t = drawer.getAttribute("data-t-freeship") || "{amount}";
      ship.textContent = remaining === 0
        ? (drawer.getAttribute("data-t-freeship-ok") || "")
        : t.replace("{amount}", money(remaining));
      bar.style.width = Math.min(100, (cart.total_price / FREE_SHIP_CENTS) * 100) + "%";
    }

    var list = drawer.querySelector("[data-cart-items]");
    var foot = drawer.querySelector("[data-cart-foot]");
    if (!list) return;
    if (cart.item_count === 0) {
      list.innerHTML = '<p class="cart-drawer__empty">' + (drawer.getAttribute("data-t-empty") || "") + "</p>";
      if (foot) foot.style.display = "none";
      return;
    }
    if (foot) foot.style.display = "";
    var sub = drawer.querySelector("[data-cart-subtotal]");
    if (sub) sub.textContent = money(cart.total_price);

    var tSize = drawer.getAttribute("data-t-size") || "Size";
    var tRemove = drawer.getAttribute("data-t-remove") || "Remove";
    list.innerHTML = cart.items.map(function (it, idx) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_180x$1$2") : "";
      var colorVal = "", sizeVal = "";
      var extraOpts = [];
      (it.options_with_values || []).forEach(function (o) {
        var n = (o.name || "").toLowerCase();
        if (n.indexOf("couleur") === 0 || n.indexOf("color") === 0 || n.indexOf("colour") === 0) { colorVal = o.value; return; }
        if (o.value && o.value !== "Default Title") extraOpts.push({ name: o.name, value: o.value });
        if (n.indexOf("taille") !== -1 || n.indexOf("size") !== -1) sizeVal = o.value;
      });
      if (!colorVal && !extraOpts.length && it.variant_title && it.variant_title !== "Default Title") {
        sizeVal = it.variant_title;
        extraOpts.push({ name: tSize, value: it.variant_title });
      }

      /* One line per option ("Taille : 50 (145 - 150 CM)" then "Taille jupe : S-M"),
         so a product with two size options never hides one of them. */
      var meta = "";
      extraOpts.forEach(function (o) {
        meta += '<p class="cart-line__variant">' + escapeHtml(o.name) + " : " + escapeHtml(o.value) + "</p>";
      });
      if (it.properties) {
        for (var pk in it.properties) {
          if (it.properties[pk] && pk.charAt(0) !== "_") {
            meta += '<p class="cart-line__note">✎ ' + escapeHtml(it.properties[pk]) + "</p>";
          }
        }
      }
      var title = escapeHtml(it.product_title) + (colorVal ? " | " + escapeHtml(colorVal) : "");
      return (
        '<div class="cart-line" data-line="' + (idx + 1) + '">' +
          '<div class="cart-line__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="80" height="100">' : "") + "</div>" +
          '<div class="cart-line__body">' +
            '<p class="cart-line__title">' + title + "</p>" +
            '<p class="cart-line__price-top">' + money(it.final_line_price) + "</p>" +
            meta +
            '<div class="cart-line__row">' +
              '<span class="cart-line__qty">' +
                '<button type="button" data-qty-minus aria-label="−">−</button>' +
                '<span class="n">' + it.quantity + "</span>" +
                '<button type="button" data-qty-plus aria-label="+">+</button>' +
              "</span>" +
            "</div>" +
          "</div>" +
          '<button type="button" class="cart-line__remove" data-line-remove aria-label="' + tRemove + '">✕</button>' +
        "</div>"
      );
    }).join("");

    /* Hide upsell cards for products already in the cart */
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    document.querySelectorAll("[data-upsell-product]").forEach(function (card) {
      card.style.display = inCart[parseInt(card.getAttribute("data-upsell-product"), 10)] ? "none" : "";
    });

    list.querySelectorAll(".cart-line").forEach(function (lineEl) {
      var line = parseInt(lineEl.getAttribute("data-line"), 10);
      var qty = parseInt(lineEl.querySelector(".n").textContent, 10);
      lineEl.querySelector("[data-qty-minus]").addEventListener("click", function () { changeLine(line, qty - 1); });
      lineEl.querySelector("[data-qty-plus]").addEventListener("click", function () { changeLine(line, qty + 1); });
      lineEl.querySelector("[data-line-remove]").addEventListener("click", function () { changeLine(line, 0); });
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function refreshCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function changeLine(line, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(variantId, quantity, properties) {
    var item = { id: parseInt(variantId, 10), quantity: quantity || 1 };
    if (properties && Object.keys(properties).length) item.properties = properties;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return refreshCart();
    }).then(openCart);
  }

  /* Quick add buttons (product cards) */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-quick-add]");
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.getAttribute("data-quick-add"), 1).catch(function () {});
  });

  /* PDP: vertical gallery — scroll to a colour's photo on colour change */
  function scrollToImage(imageId) {
    if (!imageId) return;
    var img = document.querySelector('[data-image-id="' + imageId + '"]');
    if (img) img.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  /* PDP: tabs */
  document.querySelectorAll("[data-tabs]").forEach(function (tabs) {
    tabs.querySelectorAll("[data-tab-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = btn.getAttribute("data-tab-btn");
        tabs.querySelectorAll("[data-tab-btn]").forEach(function (b) { b.classList.toggle("is-active", b === btn); });
        tabs.querySelectorAll("[data-tab-panel]").forEach(function (p) {
          p.classList.toggle("is-active", p.getAttribute("data-tab-panel") === idx);
        });
      });
    });
  });
  document.querySelectorAll("[data-open-sizing]").forEach(function (link) {
    link.addEventListener("click", function () {
      var btn = document.querySelector('[data-tab-btn="2"]');
      if (btn) btn.click();
    });
  });

  /* PDP: alteration note toggle */
  document.querySelectorAll("[data-note-toggle]").forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      var box = toggle.parentElement.querySelector("[data-note-box]");
      if (box) {
        box.hidden = !box.hidden;
        if (!box.hidden) box.querySelector("textarea").focus();
      }
    });
  });

  /* Product form (PDP) */
  document.querySelectorAll("[data-product-form]").forEach(function (root) {
    var dataEl = root.querySelector("[data-product-json]");
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = document.querySelector("[data-pdp-price]");
    var atcBtn = root.querySelector("[data-pdp-atc]");
    var eyebrow = document.querySelector("[data-color-eyebrow]");
    var selected = {};

    root.querySelectorAll("[data-option-value]").forEach(function (btn) {
      var pos = btn.getAttribute("data-option-pos");
      var val = btn.getAttribute("data-option-value");
      if (btn.classList.contains("is-selected")) selected[pos] = val;
      btn.addEventListener("click", function () {
        root.querySelectorAll('[data-option-pos="' + pos + '"]').forEach(function (b) { b.classList.remove("is-selected"); });
        btn.classList.add("is-selected");
        selected[pos] = val;
        var label = document.querySelector('[data-option-label="' + pos + '"]');
        if (label) label.textContent = val;
        if (eyebrow && btn.classList.contains("pdp-split__swatch")) eyebrow.textContent = val;
        sync(btn.classList.contains("pdp-split__swatch"));
      });
    });

    function currentVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return !selected[String(i + 1)] || selected[String(i + 1)] === opt;
        });
      });
    }
    function sync(doScroll) {
      var v = currentVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available
          ? (atcBtn.getAttribute("data-t-add") || atcBtn.textContent)
          : (atcBtn.getAttribute("data-t-soldout") || atcBtn.textContent);
      }
      /* On colour change, scroll the gallery to that colour's photo */
      if (doScroll && v.featured_image && v.featured_image.id) {
        scrollToImage(v.featured_image.id);
      }
    }
    sync(false);

    root.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.available) return;
      var properties = {};
      root.querySelectorAll('[name^="properties["]').forEach(function (field) {
        var val = field.value.trim();
        if (val) {
          var key = field.getAttribute("name").slice(11, -1);
          properties[key] = val;
        }
      });
      addToCart(v.id, 1, properties).then(function () {
        if (atcBtn) {
          var orig = atcBtn.getAttribute("data-t-add") || atcBtn.textContent;
          atcBtn.textContent = atcBtn.getAttribute("data-t-added") || orig;
          setTimeout(function () { atcBtn.textContent = orig; }, 2200);
        }
      }).catch(function () {});
    });
  });

  /* Collection sort */
  document.querySelectorAll("[data-sort-select]").forEach(function (sel) {
    sel.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sel.value);
      window.location.href = url.toString();
    });
  });

  /* ---------- GSAP reveals ---------- */
  if (window.gsap && !reducedMotion) {
    var gsap = window.gsap;
    if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);

    /* Hero timeline */
    var hero = document.querySelector(".hero");
    if (hero) {
      var tl = gsap.timeline({ defaults: { ease: "power3.out" } });
      tl.from(".hero__eyebrow", { y: 24, opacity: 0, duration: 0.9, delay: 0.2 })
        .from(".hero__title span, .hero__title em", { y: 48, opacity: 0, duration: 1.2, stagger: 0.25 }, "-=0.5")
        .from(".hero__sub", { y: 20, opacity: 0, duration: 0.9 }, "-=0.5")
        .from(".hero__cta", { y: 18, opacity: 0, duration: 0.8 }, "-=0.4")
        .from(".hero__image", { scale: 1.06, duration: 2.0, ease: "power2.out" }, 0);
    }

    /* Scroll reveals */
    if (window.ScrollTrigger) {
      document.querySelectorAll(".reveal").forEach(function (el) {
        gsap.to(el, {
          opacity: 1, y: 0, duration: 1.0, ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 88%" }
        });
      });
      /* Atelier parallax */
      document.querySelectorAll(".atelier__media img").forEach(function (img) {
        gsap.fromTo(img, { y: 0 }, {
          y: -40, ease: "none",
          scrollTrigger: { trigger: img.closest(".atelier__media"), start: "top bottom", end: "bottom top", scrub: true }
        });
      });
    }
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) {
      el.style.opacity = "1"; el.style.transform = "none";
    });
  }

  /* Initial cart count */
  refreshCart();
})();
